module.exports = __webpack_public_path__ + "static/media/31.3b4cb97e.png";